import './TransferBankHero.css'
import { Button } from "@mantine/core";
import SectionTitle from "../../../components/SectionTitle/SectionTitle";
import { useNavigate } from "react-router-dom";
import { IconArrowLeft } from "@tabler/icons-react";
import TransferBankCart from '../TransferBankCart/TransferBankCart';

export default function TransferBankHero({transferBankHeroText, transferBankCart}) {
   const {title, subtitle, returnButton} = transferBankHeroText;
   const navigate = useNavigate()

   const goBack = (event) => {
      event.preventDefault()
      navigate(-1)
   }

   return (
      <div className="transferBankHero-container">
         <SectionTitle SectionTitle downText={title} upText={subtitle} >

            <Button style={{order: -1}} onClick={goBack} variant="outline" mb={20} color='var(--color-tertiary)' >
               < IconArrowLeft style={{marginRight: '8px'}} />
               {returnButton}
            </Button>
         
         </SectionTitle>
         <TransferBankCart transferBankCart={transferBankCart}/>
      </div>
   )
}
